var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99912 12.1428V12.1616M8.92815 8.6809C8.92815 8.07799 9.40785 7.58923 9.99958 7.58923C10.5913 7.58923 11.071 8.07799 11.071 8.6809C11.071 9.28381 10.5913 9.77256 9.99958 9.77256C9.99958 9.77256 9.99912 10.0984 9.99912 10.5003M14.2853 9.99995C14.2853 12.3669 12.3665 14.2857 9.99958 14.2857C7.63265 14.2857 5.71387 12.3669 5.71387 9.99995C5.71387 7.63301 7.63265 5.71423 9.99958 5.71423C12.3665 5.71423 14.2853 7.63301 14.2853 9.99995Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionFaq);
export default __webpack_public_path__ + "static/media/question-faq.cb2f33cbd2a415364221dd33651c0018.svg";
export { ForwardRef as ReactComponent };